import React, { useState, useEffect } from "react";
import aboutImage from "../Assest/omsaiabout.jpg";

const AboutSection = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = windowWidth <= 768;
  const isTablet = windowWidth > 768 && windowWidth <= 1024;

  return (
    <div
      style={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: "center",
        justifyContent: "center",
        padding: "40px 20px",
        backgroundColor: "#f0e8e8",
        gap: "40px",
        flexWrap: "wrap",
      }}
    >
      {/* Image Section */}
      <div
        style={{
          flex: 1,
          maxWidth: isMobile ? "100%" : isTablet ? "80%" : "450px",
          textAlign: "center",
        }}
      >
        <img
          src={aboutImage}
          alt="Om Sai Credit Collection Services"
          style={{
            width: "100%",
            height: "auto",
            borderRadius: "20px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
          }}
        />
      </div>

      {/* Text Section */}
      <div
        style={{
          flex: 1,
          maxWidth: isMobile ? "100%" : isTablet ? "90%" : "600px",
        }}
      >
        <h2
          style={{
            fontSize: isMobile ? "22px" : "30px",
            fontWeight: "700",
            marginBottom: "20px",
            color: "#000",
            textAlign: isMobile ? "center" : "left",
          }}
        >
          Om Sai Credit Collection Services Pvt. Ltd.
        </h2>
        <p
          style={{
            fontSize: isMobile ? "16px" : "18px",
            lineHeight: "1.6",
            color: "#333",
            marginBottom: "15px",
            textAlign: isMobile ? "justify" : "left",
          }}
        >
          With over <strong>25 years of experience</strong>, Om Sai is a trusted,
          <strong> ISO 9001:2015 certified</strong> debt recovery agency serving
          clients across <strong>Maharashtra</strong>. We specialize in recovering
          unpaid accounts, overdue loans, vehicle finance, and more—helping
          <strong> NBFCs</strong> and financial institutions improve cash flow and
          reduce losses. <br />
          Backed by a <strong>professional team</strong> and <strong>ethical practices</strong>,
          we offer reliable recovery solutions in <strong>Pune, Mumbai, Nashik, Satara</strong>,
          and beyond.
        </p>
      </div>
    </div>
  );
};

export default AboutSection;
